import ignite from '../../services';
import {extractPageFromPath} from '../../state';

const NavigationActions = {
  PAGE_ANIMATION_COMPLETED: 'PAGE_ANIMATION_COMPLETED',
  PAGE_REQUEST_STARTED: 'PAGE_REQUEST_STARTED',
  PAGE_REQUEST_COMPLETED: 'PAGE_REQUEST_COMPLETED',
  PAGE_REQUEST_FAILED: 'PAGE_REQUEST_FAILED'
};

const NavigationDirections = {
  BACK: 'BACK',
  FORWARD: 'FORWARD',
};

const PageAnimationStages = {
  STARTED: 'animation-started',
  RUNNING: 'animation-running',
  COMPLETED: false
};

const LoadPathActions = {
  LOAD_PATHS_STARTED: 'LOAD_PATHS_STARTED',
  LOAD_PATHS_COMPLETED: 'LOAD_PATHS_COMPLETED',
  LOAD_PATHS_FAILED: 'LOAD_PATHS_FAILED'
};

const pageRequestCompleted = (nextPage, reverse) => {
  return {
    type: NavigationActions.PAGE_REQUEST_COMPLETED,
    nextPage,
    direction: reverse
      ? NavigationDirections.BACK
      : NavigationDirections.FORWARD
  };
};

const pageRequestFailed = (error) => {
  return {
    type: NavigationActions.PAGE_REQUEST_FAILED,
    error,
  };
};

const pageRequestStarted = (reverse) => {
  return {
    type: NavigationActions.PAGE_REQUEST_STARTED,
    direction: reverse
      ? NavigationDirections.BACK
      : NavigationDirections.FORWARD
  };
};

const loadPaths = () => {
  return async dispatch => {
    dispatch({ type: LoadPathActions.LOAD_PATHS_STARTED });
    try {
      const paths = await window.ignite.pageResolutionService.getPaths();
      dispatch({ type: LoadPathActions.LOAD_PATHS_COMPLETED, payload: paths });
    } catch (error) {
      dispatch({ type: LoadPathActions.LOAD_PATHS_FAILED, error });
    }
  };
};

const loadNextPage = (reverse) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { currentPageUrl } = state.pages;
    const currentPage = extractPageFromPath(currentPageUrl);
    try {
      dispatch(pageRequestStarted(reverse));
      const pageResponse = await ignite.pageResolutionService.nextPage({
        page: currentPage,
        reverse,
      });

      dispatch(pageRequestCompleted(pageResponse, reverse));
    } catch (ex) {
      dispatch(pageRequestFailed(ex));
    }
  };
};

const loadSpecificPage = (path) => {
  return async (dispatch) => {
    const currentPage = extractPageFromPath(path);

    try {
      dispatch(pageRequestStarted(false));
      const pageResponse = await ignite.pageResolutionService.loadPage({
        page: currentPage,
      });

      dispatch(pageRequestCompleted(pageResponse, false));
    } catch (ex) {
      dispatch(pageRequestFailed(ex));
    }
  };
};

const startGuide = (selectedPath) => {
  return async (dispatch) => {
    try {
      dispatch(pageRequestStarted());
      const pageResponse = await ignite.pageResolutionService.nextPage({
        page: {
          type: 'landing',
        },
        selectedPath,
      });

      dispatch(pageRequestCompleted(pageResponse, false));
    } catch (ex) {
      dispatch(pageRequestFailed(ex));
    }
  };
};

const pageAnimationCompleted = () => {
  return async dispatch => dispatch({ type: NavigationActions.PAGE_ANIMATION_COMPLETED });
};

export {
  loadPaths,
  loadNextPage,
  LoadPathActions,
  loadSpecificPage,
  NavigationActions,
  NavigationDirections,
  startGuide,
  pageAnimationCompleted,
  PageAnimationStages
};
